import { InfoCircleIcon } from "../../icons";

export const FieldLabel = ({ children, showInfo = false, htmlFor }) => (
  <div className="flex items-center gap-1">
    <label
      htmlFor={htmlFor}
      className="text-sm font-medium leading-[21px] text-text-primary"
    >
      {children}
    </label>
    {showInfo && (
      <InfoCircleIcon className="size-3 shrink-0 text-text-secondary" />
    )}
  </div>
);

export const FormInput = ({
  id,
  label,
  value,
  placeholder,
  onChange,
  type = "text",
  showInfo = false,
  trailingIcon,
  disabled = false,
  readOnly = false,
  error = "",
  className = "",
  ...restProps // Passes any additional standard input props seamlessly
}) => (
  <div className="flex w-full flex-col gap-1">
    {label && (
      <FieldLabel htmlFor={id} showInfo={showInfo}>
        {label}
      </FieldLabel>
    )}

    <div
      className={`flex h-auto w-full items-center justify-between rounded-[10px] border border-solid bg-background-surface px-4 py-2.5 transition-colors ${
        error ? "border-red-500 bg-error-500/10" : "border-divider"
      } ${disabled ? "opacity-60 cursor-not-allowed" : ""} ${
        readOnly ? "bg-background-alt cursor-default" : ""
      } ${className}`}
    >
      <input
        id={id}
        type={type}
        value={value ?? ""}
        disabled={disabled}
        readOnly={readOnly}
        onChange={onChange} // Directly forwards the native change event
        placeholder={placeholder}
        className={`w-full border-0 bg-transparent p-0 text-sm font-normal text-text-primary placeholder:text-text-secondary outline-none focus:ring-0 ${
          disabled ? "cursor-not-allowed" : readOnly ? "cursor-default" : ""
        }`}
        {...restProps}
      />
      {trailingIcon && <div className="ml-2 shrink-0">{trailingIcon}</div>}
    </div>

    {error && <p className="text-xs text-red-500">{error}</p>}
  </div>
);